
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainColour as ObiLightningLightRainColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-colour.js';
 
 
 

 
 export const ObiLightningLightRainColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-colour',
   elementClass: ObiLightningLightRainColourElement,
   events: {
     
   }
  });
 
 